"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "reward*"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Shape",
    d: "M4.16931 2.9995C4.16931 1.89521 5.13912 1 6.33545 1H10.6677C11.864 1 12.8339 1.89521 12.8339 2.9995H13.3754C14.2726 2.9995 15 3.67091 15 4.49913V5.49888C15 6.74957 14.0042 7.78536 12.7053 7.96924C12.2779 9.55158 10.8294 10.761 9.04315 10.9666V11.9973H10.6677C11.864 11.9973 12.8339 12.8925 12.8339 13.9968V14.5001C12.8339 14.7762 12.5914 15 12.2923 15H4.71085C4.41176 15 4.16931 14.7762 4.16931 14.5001V13.9968C4.16931 12.8925 5.13912 11.9973 6.33545 11.9973H7.96009V10.9666C6.17388 10.761 4.72537 9.55166 4.29787 7.96937C2.99867 7.78589 2 6.75045 2 5.49888V4.49913C2 3.67091 2.72736 2.9995 3.6246 2.9995L4.16931 2.9995ZM11.7508 2.9995C11.7508 2.44736 11.2659 1.99975 10.6677 1.99975H6.33545C5.73729 1.99975 5.25238 2.44736 5.25238 2.9995V6.99851C5.25238 8.65495 6.7071 9.99776 8.50159 9.99776C10.2709 9.99776 11.7099 8.69239 11.7499 7.06809L11.7508 2.9995ZM12.8339 6.91294C13.4648 6.70684 13.9169 6.1514 13.9169 5.49888V4.49913C13.9169 4.22306 13.6745 3.99925 13.3754 3.99925H12.8339V6.91294ZM4.16931 3.99925H3.6246C3.32552 3.99925 3.08307 4.22306 3.08307 4.49913V5.49888C3.08307 6.15134 3.53685 6.70744 4.16931 6.91333V3.99925ZM5.25238 13.9968V14.0002H11.7508V13.9968C11.7508 13.4446 11.2659 12.997 10.6677 12.997H6.33545C5.73729 12.997 5.25238 13.4446 5.25238 13.9968Z",
    fill: fill
  })));
};

exports["default"] = _default;